// Tipos del módulo BD Unificada — espejo de los payloads del microservicio tonal-ms-bd.

export type TipoContacto = 'medico' | 'dependiente' | 'quimico' | 'enfermero' | 'otro'
export type Genero = 'M' | 'F' | 'O' | 'NE'

export interface Contacto {
  id: string
  tipo: TipoContacto | string
  cedula: string | null
  nombre_completo: string
  nombre: string | null
  apellido: string | null
  email_personal: string | null
  email_corporativo: string | null
  email_preferido: string | null
  telefono: string | null
  whatsapp: string | null
  especialidad: string | null
  pais: string | null
  ciudad: string | null
  provincia: string | null
  genero: Genero | string | null
  datos: Record<string, unknown> | null
  fuente_id: string | null
  created_at: string | null
  updated_at: string | null
}

export interface ContactoListResponse {
  total: number
  pagina: number
  por_pagina: number
  items: Contacto[]
}

export interface ContactosFilters {
  pagina?: number
  por_pagina?: number
  tipo?: string
  pais?: string
  especialidad?: string
  ciudad?: string
  provincia?: string
}

export interface ContactoUpdateInput {
  tipo?: string
  cedula?: string | null
  nombre?: string | null
  apellido?: string | null
  nombre_completo?: string
  email_personal?: string | null
  email_corporativo?: string | null
  telefono?: string | null
  whatsapp?: string | null
  especialidad?: string | null
  pais?: string | null
  ciudad?: string | null
  provincia?: string | null
  genero?: string | null
  datos?: Record<string, unknown> | null
}

export interface Stats {
  total_contactos: number
  nuevos_este_mes: number
  por_tipo: Record<string, number>
}

export const TIPOS_CONTACTO: { value: TipoContacto; label: string }[] = [
  { value: 'medico', label: 'Médico' },
  { value: 'dependiente', label: 'Dependiente' },
  { value: 'quimico', label: 'Químico' },
  { value: 'enfermero', label: 'Enfermero' },
  { value: 'otro', label: 'Otro' },
]

export const GENEROS: { value: Genero; label: string }[] = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Femenino' },
  { value: 'O', label: 'Otro' },
  { value: 'NE', label: 'No especificado' },
]
